import React, { Suspense } from "react";
import LazyWrapper from "../components/lazywrapper/LazyWrapper.jsx";

class LazyErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  retry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          Failed to load page.
          <br />
          <button onClick={this.retry}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export function lazyLoad(ComponentImport) {
  const Component = React.lazy(ComponentImport);
  return (props) => (
    <LazyErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <LazyWrapper>
          <Component {...props} />
        </LazyWrapper>
      </Suspense>
    </LazyErrorBoundary>
  );
}
